<template>
  <v-container>
    <v-row v-if="this.playerid === this.shop.PlayerId">
      <v-spacer></v-spacer>
      <InventorySelect :Shopid="this.$route.params.id" />
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn color="secondary" @click="EditShop()" v-on="on">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <span>Edit Shop</span>
      </v-tooltip>
      <v-tooltip top>
        <template v-slot:activator="{ on }">
          <v-btn class="mx-2" color="red darken-1" dark @click="deleteDialog = true" v-on="on">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <span>Delete Town</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col cols="6" md="4">
        <v-card shaped class="pa-1">
          <v-card-title class="justify-center primary--text">Name</v-card-title>

          <v-card-subtitle class="text-center">{{ shop.Name }}</v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="6" md="3">
        <v-card shaped class="pa-1">
          <v-card-title class="justify-center primary--text">Town</v-card-title>
          <v-card-subtitle class="text-center">
            {{
            shop.Town.Name
            }}
          </v-card-subtitle>
        </v-card>
      </v-col>

      <v-col cols="12" md="5">
        <v-card shaped class="pa-1">
          <v-card-title class="justify-center primary--text">Description</v-card-title>
          <v-card-subtitle class="text-center">
            {{
            shop.Description
            }}
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        md="12"
        v-if="
          this.playerid === this.shop.PlayerId && shop.DndBeyondLink != null
        "
      >
        <v-card shaped class="pa-1">
          <v-card-title class="justify-center primary--text">Dnd Beyond Link</v-card-title>
          <v-card-subtitle class="text-center">
            {{
            shop.DndBeyondLink
            }}
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="12">
        <v-card shaped class="pa-1" v-if="this.playerid === this.shop.PlayerId">
          <v-card-title class="justify-center primary--text">Summary</v-card-title>
          <v-card-subtitle class="text-center">
            {{
            shop.Notes
            }}
          </v-card-subtitle>
        </v-card>
      </v-col>
    </v-row>
    <v-card shaped v-if="showInventory">
      <v-card-title class="justify-center primary--text">Inventory</v-card-title>
      <v-row class="px-2">
        <v-col cols="3">
          <v-card-subtitle class="py-0 secondary--text">Name</v-card-subtitle>
        </v-col>
        <v-col cols="2">
          <v-card-subtitle class="py-0 secondary--text">Type</v-card-subtitle>
        </v-col>
        <v-col cols="5">
          <v-card-subtitle class="py-0 secondary--text">Description</v-card-subtitle>
        </v-col>
        <v-col cols="1">
          <v-card-subtitle class="py-0 secondary--text">Qty</v-card-subtitle>
        </v-col>
        <v-col cols="1">
          <v-card-subtitle class="py-0 secondary--text">Price</v-card-subtitle>
        </v-col>
      </v-row>
      <v-row v-for="inventory in shop.Inventory" :key="inventory.name" class="px-2">
        <v-col cols="3">
          <v-card-subtitle class="py-0">
            <a class="py-0" :href="inventory.Url" target="_blank">
              <span class="blue--text" v-if="inventory.Url">{{ inventory.Name }}</span>
              <span v-if="!inventory.Url">{{ inventory.Name }}</span>
            </a>
          </v-card-subtitle>
        </v-col>
        <v-col cols="2">
          <v-card-subtitle class="py-0">{{ inventory.Type }}</v-card-subtitle>
        </v-col>
        <v-col cols="5">
          <v-card-subtitle class="py-0">
            {{
            inventory.Description
            }}
          </v-card-subtitle>
        </v-col>
        <v-col cols="1">
          <v-card-subtitle class="py-0">{{ inventory.Qty }}</v-card-subtitle>
        </v-col>
        <v-col cols="1">
          <v-card-subtitle class="py-0">{{ inventory.Price }}</v-card-subtitle>
        </v-col>
      </v-row>
    </v-card>

    <v-card class="ma-2" flat>
      <v-row>
        <v-spacer></v-spacer>
        <v-card-title
          class="justify-center primary--text"
          v-if="notes.length > 0 || this.playerid === this.shop.PlayerId"
        >Notes</v-card-title>
        <NewNote :CreatedFrom="[shop.Name]" v-if="this.playerid === this.shop.PlayerId"></NewNote>
        <v-spacer></v-spacer>
      </v-row>
      <v-row justify="center">
        <v-hover v-for="note in notes" :key="note.id">
          <template v-slot:default="{ hover }">
            <v-card max-width="350" class="ma-4">
              <v-card-subtitle class="primary--text">
                {{
                note.Note | Trim
                }}
              </v-card-subtitle>
              <v-card-text>
                <v-chip-group>
                  <v-chip class="my-0" small v-for="tag in note.tags" :key="tag">{{ tag }}</v-chip>
                </v-chip-group>
              </v-card-text>

              <v-fade-transition>
                <v-overlay v-if="hover" absolute color="#036358">
                  <v-btn
                    class="primary"
                    :to="{ name: 'EditNote', params: { id: note.id } }"
                  >See more info</v-btn>
                </v-overlay>
              </v-fade-transition>
            </v-card>
          </template>
        </v-hover>
      </v-row>
    </v-card>

    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline">Delete {{ shop.Name }}?</v-card-title>
        <v-card-text>
          If you click Delete {{ shop.Name }} will be removed for
          ever.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="red darken-1" text @click="deleteShop()">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import NewNote from "@/components/NewNote";
import InventorySelect from "@/components/InventorySelect";

import db from "@/fb";
import firebase from "firebase/app";
import "firebase/auth";

export default {
  name: "shop",
  components: { NewNote, InventorySelect },
  methods: {
    EditShop() {
      this.$router.push({
        name: "EditShop",
        params: { id: this.$route.params.id },
      });
    },
    deleteShop() {
      db.collection("shops")
        .doc(this.$route.params.id)
        .delete()
        .then(
          this.$router.push({
            name: "Town",
            params: { id: this.shop.Town.id },
          })
        );
    },
  },
  data() {
    return {
      shop: { Town: {}, Inventory: [] },
      playerid: null,
      deleteDialog: false,
      notes: [],
    };
  },
  computed: {
    showInventory() {
      //   if (typeof this.npc.Inventory === "undefined") {
      //     return false;
      //   } else {

      if (this.shop.Inventory.length > 0) {
        return true;
      }
      return false;
      // }
    },
  },
  filters: {
    Trim: function (value) {
      if (!value) return "";
      if (value.length >= 50) return value.substring(0, 50) + "...";
      return value;
    },
  },

  firestore() {
    this.$bind("shop", db.collection("shops").doc(this.$route.params.id)).then(
      (shop) => {
        if (this.playerid === shop.PlayerId) {
          db.collection("notes")
            .where("PlayerId", "==", firebase.auth().currentUser.uid)
            .where("tags", "array-contains", shop.Name)
            .get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                this.notes.push({
                  ...doc.data(),
                  id: doc.id,
                });
              });
            });
        } else {
          db.collection("notes")
            .where("Public", "==", true)
            .where("tags", "array-contains", shop.Name)
            .get()
            .then((snapshot) => {
              snapshot.forEach((doc) => {
                this.notes.push({
                  ...doc.data(),
                  id: doc.id,
                });
              });
            });
        }
      }
    );
  },
  created() {
    firebase.auth().onAuthStateChanged((cred) => {
      this.playerid = cred.uid;
    });
  },
};
</script>
